// extracted by mini-css-extract-plugin
export default {"modalContentWrapper":"ConfirmationModal_modalContentWrapper__1FNrB","title":"ConfirmationModal_title__5ATt1","text":"ConfirmationModal_text__giOjT"};